import { useRealtimeHealthContext } from '../utils/providers';
import type { RealtimeHealth } from '../utils/providers';

/**
 * Hook to access real-time connection health status
 * @returns RealtimeHealth object containing status, lastEventTime, errorCount, etc.
 */
export const useRealtimeHealth = (): RealtimeHealth => {
  return useRealtimeHealthContext();
};
